// extracted by mini-css-extract-plugin
export default {"panel":"MedicationReviewPanel_panel__dIahx"};